import { FormField, FormItem, FormLabel, FormControl, FormDescription, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { UseFormReturn } from "react-hook-form";
import { PatchPolicyFormValues } from "../../schema";
import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
interface GeneralTabProps {
  form: UseFormReturn<PatchPolicyFormValues>;
}
export function GeneralTab({
  form
}: GeneralTabProps) {
  return <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold mb-2">Basic Information</h3>
        <p className="text-sm text-muted-foreground mb-6">Configure the basic settings for your patch policy</p>
      </div>

      <FormField control={form.control} name="name" render={({
      field
    }) => <FormItem>
            <FormLabel>Policy Name</FormLabel>
            <FormControl>
              <Input {...field} placeholder="e.g., Standard Update Policy" />
            </FormControl>
            
            <FormMessage />
          </FormItem>} />

      <FormField control={form.control} name="description" render={({
      field
    }) => <FormItem>
            <FormLabel>Description (Optional)</FormLabel>
            <FormControl>
              <Textarea {...field} placeholder="Describe the purpose and scope of this policy..." />
            </FormControl>
            
            <FormMessage />
          </FormItem>} />

      <div className="border-t pt-6">
        <h3 className="text-lg font-semibold mb-6">Update Handling</h3>
        
        <FormField control={form.control} name="schedule_type" render={({
        field
      }) => <FormItem>
              <div className="flex items-center gap-2 mb-2">
                <FormLabel>Update Policy</FormLabel>
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Info className="h-4 w-4 text-muted-foreground cursor-help" />
                    </TooltipTrigger>
                    <TooltipContent className="max-w-xs">
                      <div className="space-y-2 text-sm">
                        <p><strong>Manual Approval:</strong> Updates require IT approval before installation</p>
                        <p><strong>Self-Service Available:</strong> Users can choose when to install available updates</p>
                        <p><strong>Install Immediately:</strong> Updates install automatically as soon as they're available</p>
                      </div>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              </div>
              <Select onValueChange={field.onChange} value={field.value}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Select update handling method" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value="manual">Manual Approval Required</SelectItem>
                  <SelectItem value="scheduled">Self-Service Available</SelectItem>
                  <SelectItem value="automatic">Install Immediately</SelectItem>
                </SelectContent>
              </Select>
              <FormDescription>
                Choose how updates should be handled on managed devices
              </FormDescription>
              <FormMessage />
            </FormItem>} />
      </div>
    </div>;
}